import { Injectable } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { BehaviorSubject, Observable } from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class CountryService {

  private countriesSubject: BehaviorSubject<string[]>;
  private hasLoadedCountries: boolean = false;

  constructor(
    private translate: TranslateService,
  ) {
    this.countriesSubject = new BehaviorSubject<string[]>([]);
  }

  public getCountries(): Observable<string[]> {
    if (!this.hasLoadedCountries) {
      // Load the country list based on our translation files
      const translations: any = this.translate.translations;
      // translations countains all languages, we just want to grab the list from the first one
      const countries: string[] = Object.keys(translations[Object.keys(translations)[0]]?.Countries);
      if (!countries) {
        throw new Error('Translation is not loaded or is missing Countries entry');
      }
      this.countriesSubject.next(countries);
      this.hasLoadedCountries = true;
    }
    return this.countriesSubject;
  }
}
